const al = {
  acquisition_screen_title: 'Numër i ri  Vodafone',
  acquisition_offer_step_title: 'Ofertë për ty',
  acquisition_offer_step_subtitle: 'Zgjidh planin',
  acquisition_recommended_offer: 'Rekomandim për ty',
  acquisition_offer_button_title: 'Vazhdo me këtë plan',
  acquisition_id_step_title: 'Shto të dhënat e tua personale',
  acquisition_id_step_subtitle: 'Nevojiten të dhënat e sakta të mjetit të indentifikimit në mënyrë që të verifikojmë identitetin tënd. Për të kryer këtë verifikim duhet një foto e ID-së.',
  acquisition_id_step_card_title: 'Mjeti i identifikimt ',
  acquisition_id_step_card_subtitle: 'Informacioni personal',
  acquisition_id_step_card_desc: 'Vendos detajet e mjetit të identifikimit për të verifikuar identitetin dhe për të finalizuar kërkesën.',
  acquisition_id_step_button_take_id_photo: 'Foto ID',
  acquisition_id_step_button_uploaded_id_photo: "Fotot u ngarkuan",
  acquisition_id_step_name: 'Emri',
  acquisition_id_step_surname: 'Mbiemri',
  acquisition_continue: 'Vazhdo',
  acquisition_id_step_id_number: 'Numri personal i ID-së',
  acquisition_id_step_id_wrong_format: 'Format i gabuar',
  acquisition_id_step_birthday_label: 'Ditëlindja',
  acquisition_id_step_date: 'DD',
  acquisition_id_step_month: 'MM',
  acquisition_id_step_year: 'YYYY',
  acquisition_id_step_day_not_valid: 'Data nuk është e saktë',
  acquisition_id_step_month_not_valid: 'Muaji nuk është i saktë',
  acquisition_id_step_year_not_valid: 'Viti nuk është i saktë',
  acquisition_id_step_card_address_title: 'Informacion për postën ',
  acquisition_id_step_card_address_subtitle: 'Vendos Adresën',
  acquisition_id_step_address_title: 'Dorëzimi i kartës SIM',
  acquisition_id_step_address_subtitle: 'Shto adresën ku dëshiron që karta SIM të dorëzohet',
  acquisition_id_step_city: 'Qyteti',
  acquisition_id_step_address: 'Rruga',
  acquisition_id_step_birthplace: 'Vendlindja',
  acquisition_id_step_birthcountry: 'Shteti',
  acquisition_id_step_citizenship: 'Kombësia',
  acquisition_id_step_gender: 'Gjinia',
  acquisition_id_step_document_type: 'Lloji i dokumentit',
  aquisition_id_step_issueing_date_not_valid: 'Data e lëshimit nuk është e saktë',
  acquisition_id_step_mobile: 'Numri i kontaktit',
  acquisition_id_issue_date: 'Data e lëshimit',
  acquisition_id_step_phone_number_wrong_format: 'Format i gabuar i numrit',
  acquisition_id_step_country: 'Shteti',
  acquisition_id_step_channel: 'Kanali',
  acquisition_sim_step_title: 'Zgjidh Numrin',
  acquisition_sim_step_subtitle: 'Zgjidh një nga numrat në dispozicion',
  acquisition_sim_step_choose_number: 'Shkruaj një numër që dëshiron',
  acquisition_summary_step_offer_title: 'Plani i zgjedhur',
  acquisition_summary_step_offer_subtitle: 'Plani aktivizohet pas verifikimit dhe aktivizimit',
  acquisition_summary_step_title: 'Përmbledhje',
  acquisition_summary_step_subtitle: 'Karta e re SIM do të dorëzohet brenda 48 orësh. Më pas, aktivizo shërbimin direkt nga My Vodafone tek Kërkesat e mia.',
  acquisition_summary_step_selected_sim_title: 'Kartë e re SIM Vodafone',
  acquisition_summary_step_selected_sim_subtitle: 'Numri i telefonit',
  acquisition_summary_step_delivery_subtitle: 'Adresa e dorëzimit',
  acquisition_done: 'Konfirmo',
  acquisition_order_completion_success: 'URIME!',
  acquisition_order_completion_success_button_cancel: 'Cancel',
  acquisition_order_completion_error: 'Oops!',
  acquisition_order_completion_error_default_desc: 'Dicka nuk funksionoi',
  acquisition_order_completion_success_default_desc: 'Kërkesa u dërgua me sukses. Kontrollo statusin tek Kërkesat e mia',
  acquisition_check_order: 'Kontrollo Kërkesën',
  acquisition_intro_screen_title: 'Merr një numër të ri Vodafone dhe përfito nga oferta më e mirë ',
  acquisition_intro_screen_subtitle: 'Bashkohu në familjen Vodafone dhe shijo eksperiencën më të mire digjitale në treg',
  acquisition_join_button: 'Merr një numër të ri',
  acquisition_verify_code_title: 'Kodi i verifikimit',
  acquisition_verify_code_subtitle: 'Kodi i verifikimit u dërgua drejt :',
  acquisition_verify_code_desc: 'Vendos kodin 4 shifror: ',
  acquisition_verify_code_resend_code_disabled: 'Ri-dërgo kodin (%1$s)',
  acquisition_verify_code_resend_code: 'Ri-dërgo kodin ',
  acquisition_verify_code_confirm: 'Konfirmo',
  acquisition_verify_code_cancel: 'Anullo',
  acquisition_go_back: 'Kthehu',
  acquisition_go_back_to_summary: 'Go back to summary',
  acquisition_loading_button: 'Duke u ngarkuar',
  acquisition_try_again: 'Provo përsëri',
  acquisition_default_error: 'Oops!',
  acquisition_default_error_message: 'Dicka nuk funksionoi',
  acquisition_close: 'Mbyll',
  acquisition_error_id_not_found: 'Të dhënat nuk janë të sakta.',
  acquisition_id_step_register: 'Regjistrohu',
  acqusition_MOBILE_GB: 'GB',
  acqusition_INTERNATIONAL_SMS: 'sms ndërkombëtare',
  acqusition_SMS: 'SMS',
  acqusition_INTERNATIONAL_MIN: 'minuta ndërkombëtare',
  acqusition_MIN: 'minuta',
  acquisition_offer: 'Zgjidh Planin',
  acquisition_id: 'Verifiko ID',
  acquisition_sim: 'SIM',
  acquisition_summary: 'Përmbledhje',
  acquisition_resources_error: 'Asnjë numër nuk u gjend. Ju lutem kërkoni sërish!',
  acquisition_monthly: ' /Muaj',
  acquisition_total_cost: 'Kosto totale',
  acquisition_total_cost_subtitle: 'Çfarë do të paguash',
  acquisition_start_date: 'Data e fillimit',
  acquisition_contract_duration: 'Kohëzgjatja e kontratës',
  acquisition_contract_duration_value: '%1$s Muaj',
  acquisition_contract_duration_value_one: '%1$s Muaj',
  acquisition_plan_monthly_cost: 'Kostoja e planit të ri',
  acquisition_plan_breakdown: 'Detaje',
  acquisition_breakdown_title: 'Plani yt i ri',
  acquisition_plan_bonus: 'Bonus',
  acquisition_terms: "Duke shtypur 'Konfirmo', ju pranoni ",
  acquisition_terms_link: "termat dhe kushtet",
  acquisition_terms_url: 'https://api-web-ci-vfal.vodafone.com/file/DigiAcq/TermsAndCond/AL.html',
  acquisition_policy: 'Shiko ',
  acquisition_policy_link: 'politikat e privatësisë dhe kushtet dhe afatet',
  acquisition_policy_url: 'https://api-web-ci-vfal.vodafone.com/file/DigiAcq/MoreInfo/AL.html',

  lastNameNull: "Mbiemri nuk mund të jetë bosh",
  minorAge: "Kontrata nuk mund të krijohet për një të mitur. Duhet të jeni mbi 18 vjec",
  invalidPlaceOfBirth: "Vendlindja duhet të jetë e vlefshme",
  invalidPersonalNumber: "Numri personal duhet të jetë në formatin e duhur",
  personalNumberExists: "Numri personal është ekzistues",
  invalidDate: "Data e skadencës së ID duhet të jetë më e vogel se data sotme",
  invalidID: "Ju lutem përdorni një ID te saktë",
  invalidAddressName: "Problem në validimin e adresës",
  simMismatch: "SIM i skanuar nuk është i njëjtë me atë të porositur",

  acquisition_terms_modal_title: 'Termat dhe kushtet',
  acquisition_policy_modal_title: 'Politikat e privatësisë',

  acquisition_close_modal: 'Mbyll',
  acquisition_camera_unavailable: 'Kamera e pa aksesuseshme',
  acquisition_camera_unavailable_subtitle: 'Ti nuk mund ta përdorësh funksionaliteit pasi kamera është e pa aksesueshme në pajisjen tënde',
  acquisition_camera_go_to_settings: 'Shko tek Konfigurimet',
  acquisition_camera_permission_denied_ios_subtitle: 'Ti duhet të japësh akses në kamerën e telefonit për të bërë fotot. Kontrollo konfigurimet e telefonit për të dhënë akses',
  acquisition_camera_permission_denied: 'Aksesi u refuzua',
  acquisition_camera_permission_denied_subtitle: 'Ti duhet të japësh akses në kamerën e telefonit për të bërë fotot. Kontrollo konfigurimet e telefonit për të dhënë akses',

  acquisition_orders_cancel_button: 'Anullo',
  acquisition_orders_add_manually_id: 'Shto manualisht',
  acquisition_orders_error_modal_header: 'Aktivizim i kartës SIM',
  acquisition_orders_error_modal_title: 'Diçka nuk funksionoi!',
  acquisition_orders_error_modal_desc_contract: 'Imazhi nuk mund të lexohet. Shto kodin manualisht dhe vazhdo me hapat e tjerë.',

  acquisition_order_add_manually_id_title: 'Shto detaje',
  acquisition_order_add_manually_id_question: 'Having trouble?',
  acquisition_order_add_manually_id__contract_label: 'Numri i kontratës',
  acquisition_order_add_manually_id_validation: 'Shto kodin e saktë te kartës SIM.',
  acquisition_orders_add_manually_id_confirm_button: 'Konfirmo',
  acquisition_add_manually_id_contract_label: "Numri i kontratës",
  acquisition_scan_error_modal_header: "Aktivizim i kartës SIM",
  acquisition_add_manually_id_sim_label: "Kodi i kartës SIM",

  acquisition_camera_continue: 'Vazhdo',
  acquisition_camera_retake_photo: 'Fotografo përsëri.',
  acquisition_camera_front_id: 'Fotografo pjesën e përparme të ID-së tënde.',
  acquisition_camera_back_id: 'Fotografo pjesën e prapme të ID-së tënde.',
  acquisition_camera_selfie: 'Ftografo fytyren tënde.',


  acquisition_scanning: 'Duke u skanuar...',

}

export default al
